<template>
  <v-dialog
    v-model="dialog"
    width="auto"
    max-width="600"
  >
    <v-card
      flat
      tile
    >
      <v-row
        row
        align-center
        justify-center
        wrap
      >
        <v-col xs="12">
          <v-row align-center>
            <v-spacer />
            <v-btn
              class="ma-2"
              outlined
              icon
              large
              color="red"
              @click="close"
            >
              <v-icon x-large>
                close
              </v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col
          xs="12"
          class="ma-3"
        >
          {{ message }}
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    message: null,
  }),
  methods: {
    open(message) {
      this.dialog = true;
      this.message = message;
    },
    close() {
      this.dialog = false;
      this.message = null;
    },
  },
};
</script>
